'use strict';

angular.module('dash.overlaySelector', [])

.controller('OverlaySelectorController', require('./OverlaySelectorController'))
.directive('overlaySelector', require('./OverlaySelectorDirective'))

.factory('OverlaySelectorActions', require('./OverlaySelectorActions'))
.factory('OverlaySelectorStore', require('./OverlaySelectorStore'))

.run(['OverlaySelectorStore', function(OverlaySelectorStore) {
  OverlaySelectorStore.init();
}]);


// WEBPACK FOOTER //
// ./src/app/dash/overlaySelector/index.js